<template>
  <div>
    <rabbey-table-3
      ref="table"
      v-loading="loading"
      :data="items"
      :columns="columns"
      :actions="actions"
      @rtable-push-action="handleCommand"
    />
    <InternalRequestDrawer
      ref="detail"
      :data="detailData"
      :drawer.sync="detailDrawer"
      @InternalRequestDrawerClose="detailDrawer = false"
      append-to-body
    />
  </div>
</template>

<script>
import RabbeyTable3 from "@/components/RabbeyTable3.vue";
import InternalRequestDrawer from "../internal_requests/InternalRequestDrawer.vue";

export default {
  name: "TableInternalRequest",
  props: {
    clientCode: {
      type: String,
      required: true
    }
  },
  components: {
    RabbeyTable3,
    InternalRequestDrawer
  },
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      totalItems: 0,
      skip: 0,
      loading: false,
      detailDrawer: false,
      detailData: {
        requestsId: 0,
        comments: [],
        descripcionLaga: "",
        descripcionCorta: "",
        commentReasonToReopen: "",
        Reopen: "",
        evidences: []
      },
      items: [],
      actions: [
        {
          label: "Ver",
          command: "view",
          icon: "el-icon-view"
        }
      ],
      columns: [
        {
          prop: "Id",
          label: "NO",
          width: 100,
          sortable: true,
          fixed: true
        },
        {
          prop: "ResponsableName",
          label: "Responsable",
          minWidth: 200
        },
        {
          prop: "CreadorName",
          label: "Creador",
          //   formatter: ImagePerson,
          minWidth: 200
        },
        {
          prop: "DescriptionCorta",
          label: "Descripción Corta",
          //   formatter: ImagePerson,
          minWidth: 300
        },
        {
          prop: "Description",
          label: "Detalle",
          minWidth: 300,
          formatter: (row) => {
            const html = row && row.Description ? row.Description : "";
            if (!html) return "";
            try {
              const div = document.createElement("div");
              div.innerHTML = html;
              return div.textContent || div.innerText || "";
            } catch (e) {
              return html.replace(/<[^>]*>/g, "");
            }
          }
        }
      ]
    };
  },
  created() {
    this.getItems();
  },
  watch: {
    clientCode(newVal, oldVal) {
      if (newVal && newVal !== oldVal) this.getItems();
    }
  },
  methods: {
    getItems() {
      if (!this.clientCode) return;
      this.loading = true;
      this.items = [];
      this.$http
        .get(
          `/api/InternalServiceRequest/GetInternalServiceRequestsByCustomer?customerCode=${this.clientCode}`,
          {
            timeout: 100000
          }
        )
        .then(({ data }) => {
          if (data == null) {
            this.items = [];
          } else if (Array.isArray(data)) {
            this.items = data;
          } else if (Array.isArray(data.Items)) {
            this.items = data.Items;
          } else {
            // fallback: try to find the array inside response
            this.items = data.Items || data.ItemsList || [];
          }
          this.totalItems = Array.isArray(this.items) ? this.items.length : 0;
        })
        .catch((error) => {
          this.$message.error("Error al consultar las solicitudes internas");
          console.error(error);
          this.items = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleChangePageSize(size) {
      this.pageSize = size;
      this.getItems();
    },
    handleChangeCurrentPage(page) {
      this.currentPage = page;
      this.getItems();
    },
    handleCommand(c) {
      if (c.command === "view") {
        const row = c.row || {};
        this.detailData = {
          requestsId: row.Id || 0,
          comments: [],
          descripcionLaga: row.Description || "",
          descripcionCorta: row.DescriptionCorta || "",
          commentReasonToReopen: "",
          Reopen: "",
          evidences: []
        };
        this.detailDrawer = true;
      }
    }
  }
};
</script>

<style></style>
